import React from 'react';
import { Link } from 'react-router-dom';
import { useSettings, buildAssetUrl } from '../contexts/SettingsContext';

export const Footer = () => {
  const { settings } = useSettings();
  const footerLogo = buildAssetUrl(settings?.footer_logo || settings?.logo);
  const siteName = settings?.website_name?.replace(/\s*-.*/, '') || 'EXTRA TIME';
  const description = settings?.footer_description
    || 'Platform prediksi skor sepak bola terpercaya dengan hadiah menarik.';
  const footerText = settings?.footer_text || '© 2025 EXTRA TIME. All rights reserved.';
  const menuTitle = settings?.footer_menu_title || 'Menu Cepat';
  const infoTitle = settings?.footer_info_title || 'Informasi';

  return (
    <footer className="footer" data-testid="main-footer">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <div className="flex items-center space-x-3 mb-4" data-testid="footer-brand">
              {footerLogo ? (
                <img src={footerLogo} alt={siteName} className="h-12 w-auto object-contain" data-testid="footer-logo-img" />
              ) : (
                <div className="w-12 h-12 bg-gradient-to-br from-[#D90429] to-[#B00320] rounded-xl flex items-center justify-center">
                  <span className="text-white font-black text-2xl">ET</span>
                </div>
              )}
              <span className="text-white font-black text-xl">{siteName}</span>
            </div>
            <p className="text-gray-400 text-sm" data-testid="footer-description">
              {description}
            </p>
          </div>

          <div>
            <h3 className="text-white font-bold mb-4">{menuTitle}</h3>
            <div className="space-y-2">
              <Link to="/" className="block text-gray-400 hover:text-white text-sm transition-colors">
                Beranda
              </Link>
              <Link to="/schedule" className="block text-gray-400 hover:text-white text-sm transition-colors">
                Jadwal
              </Link>
              <Link to="/leaderboard" className="block text-gray-400 hover:text-white text-sm transition-colors">
                Leaderboard
              </Link>
              <Link to="/check-ticket" className="block text-gray-400 hover:text-white text-sm transition-colors">
                Cek Tiket
              </Link>
            </div>
          </div>

          <div>
            <h3 className="text-white font-bold mb-4">{infoTitle}</h3>
            <div className="space-y-2">
              <Link to="/partners" className="block text-gray-400 hover:text-white text-sm transition-colors">
                Partner
              </Link>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 text-center">
          <p className="text-gray-400 text-sm" data-testid="footer-copyright">
            {footerText}
          </p>
        </div>
      </div>
    </footer>
  );
};
